<template>
  <cardView :title="$t('taskDefinition.title')">
    <div class="task-definitions-overview mb-3 p-0">
      <b-row class="mb-4 pr-3">
        <b-col cols="1" sm="auto" class="ml-auto">
          <router-link :to="{name: 'task-definition-add'}">
          <Button class="w-100 h-2 mb-2 mt-2 ml-3 pl-3 pr-3"
            :color="getColors.defaultColorSolidButton" :backgroundColor="getColors.defaultBackgroundColorSolidButton"
            :fontSize="'15px'" :fontWeight="'600'" :outline="true" :size="'small'" :display="'inline'"
            :width="'calc(100% - 5px)'" :padding="'2px 0'">
            <template #button-content>
              <span>{{ $t('taskDefinition.createTaskDefinitionButton') }} <i class="far fa-plus"></i></span>
            </template>
          </Button>
        </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <template>
            <ve-table v-if="getTaskDefinitions.length" 
              :max-height="700"
              class="task-definition-table" 
              :fixed-header="true" 
              row-key-field-name="rowKey" 
              :virtual-scroll-option="virtualScrollOption"
              :columns="getColumns"
              :cellSelectionOption="cellSelectionOption" 
              :row-style-option="rowStyleOption"
              :event-custom-option="customEventOptions" 
              :table-data="getTaskDefinitions" 
              />
            <div v-else>{{ $t('taskDefinition.table.noRecords') }}</div>
          </template>
        </b-col>
      </b-row>
    </div>
  </cardView>
</template>


<script>
import {mapGetters} from "vuex";
import colors from "@/assets/scss/MotivateColors.scss";
import Button from "@/components/ui/Button.vue";

import {customEventOptions} from "@/mixins/vueEasyTable/bodyCellEvents";
import CardView from "@/components/cardView.vue";

// als je functies maakt kan je er voor kiezen om ze net als de getters op te stellen. Het is bijvoorbeeld voor het
// updaten van een prijs of in ons geval miss een counter. Omdat je in de logs kan zien dat je ze aanroept.
// Als je het in de normale mutations(hieronder) zet dan kan je ze niet in de state terug vinden.
// Als je strict true zet bij de store dan kan je geen mutaties zetten hieronder. Je moet dan de
// mutaties bij de store neerzetten. Asynchrone code moet je niet in mutaties gebruiken want je kan niet goed
// traceren wanneer iets veranderd is. Je moet hiervoor acties gebruiken. Deze zorgt voor asychronus. Aflevering actions

// v-bind kan je data aan bijvoorbeeld een href koppelen omdat je niet {{}} dit kan gebruiken in bijvoorbeeld text.
// in de data return doe je dan bijv groen: DitIsEenAnderStinkyWebsite. met v-bind doe je v-bind:href="groen".
// In de method kan je referen naar de data door this te gebruiken
// Met v-html bind je data aan je html dus <a v-html="groen">uitkomst<a>(KOMST MET SECURITY ISSUES, cross-side hacking)
// v-on listener v-on:click
// mixins zijn dingen die over components kan gebruiken. Je hebt bijvoorbeeld het tabel. De vormgeving is hetzelfde
// bij meerdere components maar de data is anders. Je kan dan gebruik maken van mixins
export default {
  name: "TaskDefinitionsOverview",
  components: {CardView, Button},
  mixins: [customEventOptions],
  data() {
    return {
      cellSelectionOption: {
        enable: false,
      },
      virtualScrollOption: {
        enable: true,
      },
      rowStyleOption: {
        stripe: true,
        clickHighlight: true,
        hoverHighlight: true,
      }
    }
  },
  computed: {
    ...mapGetters('taskDefinitions', ['getTaskDefinitions', 'getTaskDefinitionsById']),
    getColumns() {
      return [
        {
          field: "name",
          key: '1',
          title: this.$t('taskDefinition.table.name'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <div class="task-definition-name-cell">
                  <div class="task-definition-name">{row.name}</div>
                </div>);
          }
        },
        {
          field: "type",
          key: '2',
          title: this.$t('taskDefinition.table.type'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <div class="task-definition-type-cell">
                  <div class="task-definition-type">{this.$t('taskDefinition.taskDefinitionType.'+ row.type)}</div>
                </div>);
          }
        },
        {
          field: "intervalType",
          key: '3',
          title: this.$t('taskDefinition.table.intervalType'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <div class="task-definition-intervalType-cell">
                  <div class="task-definition-intervalType">{this.$t('taskDefinition.intervalType.'+ row.intervalType)}</div>
                </div>);
          }
        },
        {
          field: "interval",
          key: '4',
          title: this.$t('taskDefinition.table.interval'),
          align: "left",
        },
        {
          field: "amountOfSubtasks",
          key: '5',
          title: this.$t('taskDefinition.table.amountOfSubtasks'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <div class="task-definition-amountOfSubtasks-cell">
                  <div class="task-definition-amountOfSubtasks">{this.$t('taskDefinition.intervalType.'+ row.amountOfSubtasks ? row.amountOfSubtasks : 0)}</div>
                </div>);
          }
        },
        {
          field: "actions",
          key: '6',
          title: this.$t('taskDefinition.table.actions'),
          align: "left",
          functions: [
            {id: 'delete-taskDefinition-button', handler: this.deleteTaskDefinition},
            {id: 'edit-taskDefinition-button', handler: this.editTaskDefinition}
          ],
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button tag="edit-taskDefinition-button"
                            class="framework-text-button-primary">{this.$t('ui.edit')}
                    </button>
                  </div>
                  <div class="col-12 col-md-6">
                    <i tag="delete-taskDefinition-button"
                       class="framework-text-button-primary far fa-trash delete"></i>
                  </div>
                </div>
            )
          }
        }
      ]
    },
    getColors() {
      return colors
    },
  },
  methods: {
    async editTaskDefinition($event) {
      this.$router.push({name: 'task-definition-edit', params: {id: $event.row.id}})

    },
    async deleteTaskDefinition($event) {
      const deleteSwal = await this.$swal({
        title: this.$t("taskDefinition.delete.title"),
        html: this.$t("taskDefinition.delete.text") + " " + $event.row.name,
        icon: 'error',
        customClass: 'm-swal-delete',
        confirmButtonText: this.$t("taskDefinition.delete.confirm"),
        showCancelButton: true,
        cancelButtonText: this.$t('ui.cancel'),
        reverseButtons: true
      });
      if (deleteSwal.value) {
        await this.$store.dispatch('taskDefinitions/delete', $event.row.id);
        this.swalToastSuccess(this.$t("taskDefinition.delete.toast.success"))
      }
    }
  },
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/desktop/ve-table-desktop.scss";
@import "@/assets/scss/components/desktop/frameworkButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkTextButtonDesktop.scss";
@import "@/assets/scss/_overwritesNewUi.scss";
@import "../../assets/scss/MotivateColors";
</style>